/**
 * @desc 搜索报警规则(旧版)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AlertSearchRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AlertResponse>>> {
  return defHttp.post({
    url: '/web/alert/rule/search',
    data,
  });
}

export function mock(
  data: defs.AlertSearchRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AlertResponse>>> {
  return defHttp.post({
    url: '/mock/web/alert/rule/search',
    data,
  });
}
